const CDN_HOST_MARKERS = ['cdninstagram.com', 'fbcdn.net'] as const;

export function isCdnBlockedImageHost(url: string): boolean {
    const lower = url.toLowerCase();
    return CDN_HOST_MARKERS.some((marker) => lower.includes(marker));
}

/** Route Instagram/Facebook CDN images through our API proxy (CORP blocks direct <img> embeds). */
export function toProxiedCdnImageSrc(url: string): string {
    if (isCdnBlockedImageHost(url)) {
        return `/api/mealpai-ai/proxy-image?url=${encodeURIComponent(url)}`;
    }
    return url;
}
